import { type Logo } from '~/domains/core';
import { useGetDataByDomain } from '~/infrastructure';

export default (): Logo => {
  const { getLogoData } = useGetDataByDomain();

  return getLogoData();
};
